import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  authFlag: false,
  userDetails: [],
  userEcomDetails: [],
  changePwd: false,
  pwd: "",
  lookup: [],
  usereditBool: false,
  userUpdateObject: {},
  paginationCount: [],
  activeKey: "11",
  regin: [],
  Division: [],
  submodule: [],
  currentModule: "",
  viewDepartment: "",
};

export const authSlice = createSlice({
  name: "authScreen",
  initialState,
  reducers: {
    setViewdepartment: (state, action) => {
      state.viewDepartment = action.payload;
    },
    setCurrentsubmodule: (state, action) => {
      state.currentModule = action.payload;
    },
    setSubmodule: (state, action) => {
      state.submodule = action.payload;
    },
    setFlagAuthVal: (state, actions) => {
      state.authFlag = actions.payload;
    },
    setUserDetails: (state, actions) => {
      state.userDetails = actions.payload;
    },
    setEcomUserDetails: (state, actions) => {
      state.userEcomDetails = actions.payload;
    },
    setLookup: (state, actions) => {
      state.lookup = actions.payload;
    },
    setChangePassword: (state, actions) => {
      state.changePwd = actions.payload;
    },
    setPassword: (state, actions) => {
      state.pwd = actions.payload;
    },
    setEditBool: (state, actions) => {
      state.usereditBool = actions.payload;
    },
    setActiveKey: (state, actions) => {
      state.activeKey = actions.payload;
    },
    setUserUpdateDataObject: (state, actions) => {
      state.userUpdateObject = actions.payload;
    },
    setDeptCount: (state, actions) => {
      state.paginationCount = actions.payload;
    },

    setReginSlice: (state, actions) => {
      // console.log("actions.payload", actions.payload);

      state.regin = actions.payload;
    },

    setDivisionSlice: (state, actions) => {
      // console.log("actions.payload", actions.payload);

      state.Division = actions.payload;
    },

    setComponent: (state, action) => {
      state.lookup = state.lookup.map((data) =>
        data.key === "INV_DEPT" ? { ...data, options: action.payload } : data
      );
    },
  },
});
export const {
  setFlagAuthVal,
  setUserDetails,
  setLookup,
  setChangePassword,
  setPassword,
  setEditBool,
  setUserUpdateDataObject,
  setDeptCount,
  setActiveKey,
  setComponent,
  setEcomUserDetails,
  setReginSlice,
  setDivisionSlice,
  setSubmodule,
  setCurrentsubmodule,
  setViewdepartment,
} = authSlice.actions;
export default authSlice.reducer;
